import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {MergeQueueLink} from './MergeQueueLink'

export function AddedToMergeQueueText({info}: {info: IssueEventInfo}) {
  return (
    <>
      {'added this pull request to the '}
      <MergeQueueLink mergeQueueUrl={info.mergeQueueUrl} />
    </>
  )
}
